import { PdfServiceReports } from '@hcs/types';

import { usePdfState } from './usePdfState';

export const usePdfPayload = <D extends PdfServiceReports>() => {
  return usePdfState<D>().data;
};
